import React from "react";
import { rewardsOverviewText } from "../../settings/Constants";
import Banner from "./Banner";
import Card from "./Card";
import PrevArrow from "../UI/Icons/PrevArrow";
import NextArrow from "../UI/Icons/NextArrow";
import Line from "./Line";
import Footer from "./Footer";
import Carousel from "react-bootstrap/Carousel";
import styled, { css } from "styled-components";
import { rem } from "polished";
import PropTypes from "prop-types";

const StyledCarousel = styled(Carousel)`
  .carousel-control-next,
  .carousel-control-prev {
    width: 2%;
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  .sr-only-focusable:active,
  .sr-only-focusable:focus {
    position: static;
    width: auto;
    height: auto;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }
`;

const CardContainer = styled.div`
  margin: ${rem("40px")} ${rem("0px")} ${rem("16px")};
  padding: ${rem("0px")} ${rem("10px")};
  display: flex;
  justify-content: space-evenly;
`;

const IconContainer = styled.div`
  width: ${rem("284px")};
  height: ${rem("95px")};

  ${({ image }) => css`
    background-image: url(${image});
    background-size: cover;
    background-position: center;
  `}
`;

const CardPrices = styled.div`
  width: ${rem("291px")};
  position: absolute;
  bottom: ${rem("26px")};
`;

const CardText = styled.div`
  text-align: center;
  max-width: ${rem("252px")};
  line-height: ${rem("24px")};
  margin: ${rem("0px")} auto;

  ${({ type }) =>
    type == "title" &&
    css`
      color: #343638;
      font-size: ${rem("16px")};
      font-weight: 500;
      margin-top: ${rem("22px")};
    `}

  ${({ type }) =>
    type == "description" &&
    css`
      color: #666666;
      font-size: ${rem("14px")};
      font-weight: 400;
      margin-top: ${rem("8px")};
    `}

  ${({ type }) =>
    type == "retailPrice" &&
    css`
      color: #666666;
      font-size: ${rem("14px")};
      font-weight: 400;
    `}

  ${({ type }) =>
    type == "memberPrice" &&
    css`
      color: #343638;
      font-size: ${rem("14px")};
      font-weight: 400;
    `}
`;

const Disclaimer = styled.div`
  max-width: ${rem("674px")};
  font-size: ${rem("12px")};
  line-height: ${rem("20px")};
  text-align: center;
  color: #666666;
  margin: ${rem("16px")} auto ${rem("0px")};

  > a {
    text-decoration: underline;
    color: #666666;

    &:hover {
      color: #666666;
    }
  }
`;

const InStay = ({
  widgetIdentifier,
  instayVouchers,
  coloredTiles,
  primaryColor,
  currencyCode,
}) => {
  return (
    <div>
      <Banner
        backgroundImg={
          widgetIdentifier.includes("yotel")
            ? rewardsOverviewText.instaySection.bannerImgYotel
            : rewardsOverviewText.instaySection.bannerImg
        }
        title={rewardsOverviewText.instaySection.title}
        subtitle={rewardsOverviewText.instayCard.description}
        coloredTiles={coloredTiles}
        primaryColor={primaryColor}
      />
      <StyledCarousel
        indicators={false}
        prevIcon={instayVouchers.length > 1 ? <PrevArrow /> : <div></div>}
        nextIcon={instayVouchers.length > 1 ? <NextArrow /> : <div></div>}
        interval={100000}
      >
        {instayVouchers.map((group, key) => (
          <Carousel.Item key={key}>
            <CardContainer>
              {group.map((instayItem) => (
                <Card key={instayItem.voucher_id} type="instay">
                  <IconContainer
                    image={instayItem.image_url.replace("//", "http://")}
                  />
                  <CardText type="title">{instayItem.name}</CardText>
                  <CardText type="description">
                    {instayItem.short_description}
                  </CardText>
                  <CardPrices>
                    <CardText type="retailPrice">{`${rewardsOverviewText.instaySection.retailPrice}: ${currencyCode}${instayItem.retail_amount}.00`}</CardText>
                    <CardText type="memberPrice">{`${rewardsOverviewText.instaySection.memberPrice}: ${currencyCode}${instayItem.amount}.00`}</CardText>
                  </CardPrices>
                </Card>
              ))}
            </CardContainer>
          </Carousel.Item>
        ))}
      </StyledCarousel>
      <Disclaimer>
        <a href="https://theguestbook.com/faq#In-stay-cash" target="_blank">
          {rewardsOverviewText.learnMore}
        </a>
      </Disclaimer>
      <Line />
      <Footer widgetIdentifier={widgetIdentifier} />
    </div>
  );
};

InStay.propTypes = {
  widgetIdentifier: PropTypes.string.isRequired,
  instayVouchers: PropTypes.array.isRequired,
  coloredTiles: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  primaryColor: PropTypes.string.isRequired,
};

export default InStay;
